import { ReactNode } from 'react';

import { Column, Row } from 'components/Blocks';
import { UserAvatarGroup } from 'components/UserAvatar';
import { EntityStatusTag } from 'components/Entities';

import { useProjectProfile } from '../context';

interface Props {
  children: ReactNode;
}

export function InvoiceWrapper({ children }: Props) {
  const { project } = useProjectProfile();

  const { invoice } = project;

  return (
    <Column className="pb-10">
      <Row>
        <UserAvatarGroup users={[invoice.owner, invoice.subOwner]} />

        <EntityStatusTag
          target="invoiceControl"
          status={invoice.status}
          round={false}
          size="medium"
        />
      </Row>

      {children}
    </Column>
  );
}
